import { Theme } from "@120wateraudit/waterworks";
import styled from "styled-components";

const PageHeader = styled.h1`
  &&& {
    font-weight: 700;
    font-size: 30px;
  }
  a {
    color: ${Theme.palette.secondary} !important;
    text-decoration: none;
    &:hover {
      color: ${Theme.palette.secondary} !important;
      opacity: 0.8;
    }
  }
`;

export default PageHeader;
